import type { LoggerPort } from '@omnea-app/packages/universal/general/observability/LoggerPort'

export function safeParseJson<ExpectedShape>(
  jsonString: string | null | undefined,
  logger: LoggerPort = console
): ExpectedShape | null {
  if (typeof jsonString !== 'string') {
    return null
  }

  try {
    // 💡: Add optional Zod schema to validate the parsed JSON
    return JSON.parse(jsonString) as ExpectedShape
  } catch (error) {
    logger.error('Failed to parse JSON string', {
      errorName: error instanceof Error ? error.name : 'Unknown',
      inputLength: jsonString.length,
    })
    return null
  }
}
